"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var profile_container_1 = __importDefault(require("../views/profile-container"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var game_area_1 = require("../utilities/game-area");
var stack_container_1 = __importStar(require("../views/stack-container"));
var sheet_1 = __importDefault(require("../views/sheet"));
var reaction_row_1 = __importDefault(require("../views/reaction-row"));
var message_button_1 = require("../views/message-button");
var page_button_1 = __importStar(require("../views/page-button"));
var color_1 = require("../utilities/color");
var i18next_1 = __importDefault(require("i18next"));
var INBOX_PAGE_STATUS_HEIGHT = 48;
var INBOX_ROWS = 6;
var InboxState = /** @class */ (function (_super) {
    __extends(InboxState, _super);
    function InboxState(app, client) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        return _this;
    }
    Object.defineProperty(InboxState.prototype, "profileContainer", {
        get: function () {
            if (!this._profileContainer) {
                this._profileContainer = new profile_container_1.default(this._app.loader.resources);
                this._profileContainer.scale.set(0.5);
                this._profileContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
            }
            return this._profileContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "backButton", {
        get: function () {
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, this.hideSheet.bind(this));
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("inbox_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "sheet", {
        get: function () {
            if (!this._sheet) {
                this._sheet = new sheet_1.default(this._app.loader.resources.ui.textures);
                this._sheet.contentContainer.addChild(this.pageContainer);
                this._sheet.contentContainer.addChild(this.previousPageButton);
                this._sheet.contentContainer.addChild(this.nextPageButton);
            }
            return this._sheet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "reactionRows", {
        get: function () {
            if (!this._reactionRows) {
                this._reactionRows = [];
                for (var i = 0; i < INBOX_ROWS; i++) {
                    var button = new reaction_row_1.default(this._app.loader.resources.ui.textures, game_area_1.GAME_SAFE_AREA.width - 12 * 2);
                    this._reactionRows.push(button);
                }
            }
            return this._reactionRows;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "reactionsContainer", {
        get: function () {
            if (!this._reactionsContainer) {
                this._reactionsContainer = new stack_container_1.default(this.reactionRows, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 14,
                    minWidth: game_area_1.GAME_SAFE_AREA.width
                });
                this._reactionsContainer.position.set(game_area_1.GAME_SAFE_AREA.left, this.titleContainer.y + this.titleContainer.height + 16);
            }
            return this._reactionsContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "pageContainer", {
        get: function () {
            if (!this._pageContainer) {
                this._pageContainer = stack_container_1.default.Group([this.pageStatusLabel], 1, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 0,
                    minHeight: INBOX_PAGE_STATUS_HEIGHT
                }, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 0,
                    minWidth: game_area_1.GAME_SAFE_AREA.width
                });
            }
            return this._pageContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "previousPageButton", {
        get: function () {
            if (!this._previousPageButton) {
                this._previousPageButton = new page_button_1.default(this._app.loader.resources.ui.textures, page_button_1.PAGE_BUTTON_TYPE.PREVIOUS, this.onPreviousPage.bind(this));
                this._previousPageButton.position.set(game_area_1.GAME_SAFE_AREA.left, (INBOX_PAGE_STATUS_HEIGHT - this.previousPageButton.height) * 0.5);
            }
            return this._previousPageButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "nextPageButton", {
        get: function () {
            if (!this._nextPageButton) {
                this._nextPageButton = new page_button_1.default(this._app.loader.resources.ui.textures, page_button_1.PAGE_BUTTON_TYPE.NEXT, this.onNextPage.bind(this));
                this._nextPageButton.position.set(game_area_1.GAME_SAFE_AREA.right - this.nextPageButton.width, (INBOX_PAGE_STATUS_HEIGHT - this.nextPageButton.height) * 0.5);
            }
            return this._nextPageButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "pageStatusLabel", {
        get: function () {
            if (!this._pageStatusLabel) {
                this._pageStatusLabel = new PIXI.Text("");
                this._pageStatusLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    fontSize: 19,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._pageStatusLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InboxState.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (value) {
            if (!this.isValidPage(value)) {
                return;
            }
            this._currentPage = value;
            this.previousPageButton.visible = this.isValidPage(value - 1);
            this.nextPageButton.visible = this.isValidPage(value + 1);
            this.pageStatusLabel.text = i18next_1.default.t("inbox_page_status")
                .replace("[current]", String(value + 1))
                .replace("[total]", String(this._numberOfPages));
            this.updateElements();
            this._client.sendEvent("inbox_paged", {
                current: value + 1,
                total: this._numberOfPages
            });
        },
        enumerable: false,
        configurable: true
    });
    InboxState.prototype.didEnterFrom = function (previousState) {
        var _a, _b;
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.profileContainer);
        this._app.stage.addChild(this.reactionsContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.sheet);
        this._reactions = (_b = (_a = this._client.inbox) === null || _a === void 0 ? void 0 : _a.reactions) !== null && _b !== void 0 ? _b : [];
        this.showSheet();
        this._client.sendEvent("inbox_entered");
    };
    InboxState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.profileContainer);
        this._app.stage.removeChild(this.reactionsContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.sheet);
    };
    InboxState.prototype.showSheet = function () {
        var numberOfPages = 1;
        if (this._reactions.length != 0) {
            numberOfPages = Math.ceil(this._reactions.length / INBOX_ROWS);
        }
        this._numberOfPages = numberOfPages;
        this.currentPage = 0;
        this.sheet.show(false, false);
        this.sheet.show(true, true);
    };
    InboxState.prototype.hideSheet = function () {
        var _this = this;
        this.sheet.show(false, true, function () {
            _this.stateMachine.pop();
        });
    };
    InboxState.prototype.updateElements = function () {
        for (var i = 0; i < this.reactionRows.length; i++) {
            var row = this.reactionRows[i];
            var elementIndex = this.elementIndex(i);
            row.alpha = elementIndex < this._reactions.length ? 1 : 0;
            if (row.alpha == 0) {
                continue;
            }
            var reaction = this._reactions[elementIndex];
            row.configureAppearance(reaction.senderName, i18next_1.default.t(reaction.type + "_" + reaction.value), reaction.type == "emoji" ? message_button_1.MESSAGE_BUTTON_STYLE.EMOJI : message_button_1.MESSAGE_BUTTON_STYLE.REGULAR, reaction.date.toLocaleDateString() + " - " + reaction.date.toLocaleTimeString());
        }
        this.reactionsContainer.layoutChildren();
    };
    InboxState.prototype.isValidPage = function (page) {
        return page >= 0 && page <= this._numberOfPages - 1;
    };
    InboxState.prototype.onPreviousPage = function () {
        this.currentPage -= 1;
    };
    InboxState.prototype.onNextPage = function () {
        this.currentPage += 1;
    };
    InboxState.prototype.elementIndex = function (offset) {
        return this.currentPage * INBOX_ROWS + offset;
    };
    return InboxState;
}(state_1.default));
exports.default = InboxState;
